"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.RESIZER_ATTRIBUTE_ID = void 0;
var _react = require("react");
var _tableResizerStore = require("./tableResizerStore");
function _slicedToArray(r, e) { return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t.return && (u = t.return(), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(r) { if (Array.isArray(r)) return r; }
function _toConsumableArray(r) { return _arrayWithoutHoles(r) || _iterableToArray(r) || _unsupportedIterableToArray(r) || _nonIterableSpread(); }
function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _iterableToArray(r) { if ("undefined" != typeof Symbol && null != r[Symbol.iterator] || null != r["@@iterator"]) return Array.from(r); }
function _arrayWithoutHoles(r) { if (Array.isArray(r)) return _arrayLikeToArray(r); }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; } /**
 * @copyright
 * Copyright (c) 2023 Accretive Technology Group, Inc. All rights
 * reserved. For use only by Accretive Technology, its employees
 * and contractors. DO NOT DISTRIBUTE.
 */
var MIN_WIDTH = 50;
var RESIZER_ATTRIBUTE_ID = exports.RESIZER_ATTRIBUTE_ID = "data-resizer-id";
var getTableByResizerId = function getTableByResizerId(id) {
  var element = document.querySelectorAll("table[".concat(RESIZER_ATTRIBUTE_ID, "=\"").concat(id, "\"]"))[0];
  return element instanceof HTMLTableElement ? element : null;
};
var isTableCellArray = function isTableCellArray(array) {
  if (array.length < 1) {
    return false;
  }
  return array.every(function (item) {
    return item instanceof HTMLTableCellElement;
  });
};
var getHeaderByResizerId = function getHeaderByResizerId(id) {
  var table = getTableByResizerId(id);
  if (!table) {
    return [];
  }
  var elements = Array.from(table.querySelectorAll("th[".concat(RESIZER_ATTRIBUTE_ID, "=\"").concat(id, "\"]")));
  return isTableCellArray(elements) ? elements : [];
};
var setResizer = function setResizer(headers, setter) {
  var position = 0;
  headers.forEach(function (item) {
    return setter(function (prev) {
      var updated = _toConsumableArray(prev);
      var headerDetails = item.getBoundingClientRect();
      position += headerDetails.width;
      updated[item.cellIndex] = {
        x: headerDetails.x,
        width: headerDetails.width,
        position: position
      };
      return updated;
    });
  });
};
var useTableResizer = function useTableResizer(id, tableWidth) {
  var _useState = (0, _react.useState)([]),
    _useState2 = _slicedToArray(_useState, 2),
    headers = _useState2[0],
    setHeaders = _useState2[1];
  var _useState3 = (0, _react.useState)(false),
    _useState4 = _slicedToArray(_useState3, 2),
    canUpdate = _useState4[0],
    setCanUpdate = _useState4[1];
  (0, _react.useEffect)(function () {
    if (!id || !tableWidth) {
      return;
    }
    var th = getHeaderByResizerId(id);
    if (th.length < 1) {
      return;
    }
    var storage = (0, _tableResizerStore.getTableResizerStore)(id);
    if (storage) {
      setHeaders(storage);
    } else {
      setResizer(th, setHeaders);
    }
    setCanUpdate(true);
  }, [id, tableWidth]);
  var updateHeaders = (0, _react.useCallback)(function () {
    var th = getHeaderByResizerId(id);
    th.forEach(function (item) {
      var percentage = headers[item.cellIndex].width / (tableWidth / 100);
      item.style.setProperty("width", "".concat(percentage, "%"));
    });
    setResizer(th, setHeaders);
  }, [headers, id, tableWidth]);
  (0, _react.useEffect)(function () {
    if (!id || !canUpdate) {
      return;
    }
    updateHeaders();
    (0, _tableResizerStore.setTableResizerStore)(id, headers);
    setCanUpdate(false);
  }, [canUpdate, headers, id, updateHeaders]);
  var updateResizer = function updateResizer(actualIndex, width) {
    setHeaders(function (prev) {
      var updated = _toConsumableArray(prev);
      var positions = updated.map(function (item) {
        return item.position;
      });
      var prevResizerPosition = positions[actualIndex - 1] ? positions[actualIndex - 1] : 0;
      var actualResizerPosition = prevResizerPosition + (width < MIN_WIDTH ? MIN_WIDTH : width);
      var nextResizerPosition = positions[actualIndex + 1] ? positions[actualIndex + 1] - MIN_WIDTH : positions[positions.length - 1];
      var positionUpdate = actualResizerPosition > nextResizerPosition ? nextResizerPosition : actualResizerPosition;
      updated[actualIndex].width = positionUpdate - prevResizerPosition;
      updated[actualIndex].position = positionUpdate;
      if (updated[actualIndex + 1]) {
        updated[actualIndex + 1].width = updated[actualIndex + 1].position - updated[actualIndex].position;
      }
      return updated;
    });
  };
  var handleResize = function handleResize(index) {
    return function () {
      var table = getTableByResizerId(id);
      if (!table) {
        return;
      }
      var handleResizeMouseMove = function handleResizeMouseMove(_ref) {
        var clientX = _ref.clientX,
          movementX = _ref.movementX;
        setCanUpdate(false);
        updateResizer(index, clientX - movementX - headers[index].x);
      };
      var handleResizeMouseUp = function handleResizeMouseUp() {
        document.removeEventListener("mousemove", handleResizeMouseMove);
        document.removeEventListener("mouseup", handleResizeMouseUp);
        table.style.userSelect = "auto";
        table.style.webkitUserSelect = "auto";
        setCanUpdate(true);
      };
      document.addEventListener("mousemove", handleResizeMouseMove);
      document.addEventListener("mouseup", handleResizeMouseUp);
      table.style.userSelect = "none";
      table.style.webkitUserSelect = "none";
    };
  };
  var handleReset = function handleReset() {
    var tableHeaders = getHeaderByResizerId(id);
    tableHeaders.forEach(function (item) {
      item.style.removeProperty("width");
    });
    var th = getHeaderByResizerId(id);
    setResizer(th, setHeaders);
    setCanUpdate(true);
  };
  return {
    headers: headers,
    handleResize: handleResize,
    handleReset: handleReset
  };
};
var _default = exports.default = useTableResizer;